import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=1f163898&"
import script from "./SuccessModal.vue?vue&type=script&lang=js&"
export * from "./SuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f163898')) {
      api.createRecord('1f163898', component.options)
    } else {
      api.reload('1f163898', component.options)
    }
    module.hot.accept("./SuccessModal.vue?vue&type=template&id=1f163898&", function () {
      api.rerender('1f163898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accomodation/SuccessModal.vue"
export default component.exports